import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=2ae6e924"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3276139710/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae6e924')) {
      api.createRecord('2ae6e924', component.options)
    } else {
      api.reload('2ae6e924', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=2ae6e924", function () {
      api.rerender('2ae6e924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layouts/Dashboard.vue"
export default component.exports